function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/no-empty-function */

import axios from "axios";
var AjaxService = /*#__PURE__*/function () {
  function AjaxService(uiStore) {
    var onRequestConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var onRequestConfigError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    var onResponse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
    var onResponseError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
    var onNoServerResponse = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
    _classCallCheck(this, AjaxService);
    _defineProperty(this, "uiStore", void 0);
    _defineProperty(this, "onRequestConfig", void 0);
    _defineProperty(this, "onRequestConfigError", void 0);
    _defineProperty(this, "onResponse", void 0);
    _defineProperty(this, "onResponseError", void 0);
    _defineProperty(this, "onNoServerResponse", void 0);
    this.uiStore = uiStore;
    this.onRequestConfig = onRequestConfig;
    this.onRequestConfigError = onRequestConfigError;
    this.onResponse = onResponse;
    this.onResponseError = onResponseError;
    this.onNoServerResponse = onNoServerResponse;
  }
  return _createClass(AjaxService, [{
    key: "doAjax",
    value: function () {
      var _doAjax = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(method, path, data) {
        var basePath, apiPath, uri, config, request, _response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              basePath = process.env.CONTEXT_PATH;
              apiPath = "/api";
              uri = "".concat(basePath).concat(apiPath).concat(path, "?v=").concat(Date.now());
              config = {
                method: method,
                url: uri,
                data: data ? JSON.stringify(data) : null,
                headers: {
                  "Content-Type": "application/json"
                }
              };
              this.onRequestConfig(config);
              request = axios(config);
              _context.p = 1;
              _context.n = 2;
              return request;
            case 2:
              _response = _context.v;
              //console.debug(`request ${uri} - config ${JSON.stringify(response)}`)
              this.onResponse(_response);
              return _context.a(2, Promise.resolve(_response));
            case 3:
              _context.p = 3;
              _t = _context.v;
              if (!_t.response) {
                _context.n = 4;
                break;
              }
              this.onResponseError(this.uiStore, _t);
              return _context.a(2, Promise.reject(_t));
            case 4:
              if (!_t.request) {
                _context.n = 5;
                break;
              }
              this.onNoServerResponse(_t);
              /*  console.debug(
                   `no response received ${uri} - error ${JSON.stringify(
                       error.request
                   )}`
               ) */
              return _context.a(2, Promise.reject(_t));
            case 5:
              this.onRequestConfigError(_t);
              /* console.debug(
                  `request config error ${uri} - error ${JSON.stringify(
                      error.message
                  )}`
              ) */

              /* console.debug(
                  `request ${uri} - config ${JSON.stringify(error.config)}`
              ) */
              return _context.a(2, Promise.reject(_t));
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function doAjax(_x, _x2, _x3) {
        return _doAjax.apply(this, arguments);
      }
      return doAjax;
    }()
  }, {
    key: "doAjaxHeader",
    value: function () {
      var _doAjaxHeader = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(method, path, data, headers) {
        var basePath, apiPath, uri, config, request, _response2, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              basePath = process.env.CONTEXT_PATH;
              apiPath = "/api";
              uri = "".concat(basePath).concat(apiPath).concat(path, "?v=").concat(Date.now());
              config = {
                method: method,
                url: uri,
                data: data ? data : null,
                headers: headers
              };
              this.onRequestConfig(config);
              request = axios(config);
              _context2.p = 1;
              _context2.n = 2;
              return request;
            case 2:
              _response2 = _context2.v;
              //console.debug(`request ${uri} - config ${JSON.stringify(response)}`)
              this.onResponse(_response2);
              return _context2.a(2, Promise.resolve(_response2));
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              if (!_t2.response) {
                _context2.n = 4;
                break;
              }
              this.onResponseError(_t2);
              return _context2.a(2, Promise.reject(_t2));
            case 4:
              if (!_t2.request) {
                _context2.n = 5;
                break;
              }
              this.onNoServerResponse(_t2);
              /*  console.debug(
                   `no response received ${uri} - error ${JSON.stringify(
                       error.request
                   )}`
               ) */
              return _context2.a(2, Promise.reject(_t2));
            case 5:
              this.onRequestConfigError(_t2);
              /*  console.debug(
                   `request config error ${uri} - error ${JSON.stringify(
                       error.message
                   )}`
               ) */

              /* console.debug(
                  `request ${uri} - config ${JSON.stringify(error.config)}`
              ) */
              return _context2.a(2, Promise.reject(_t2));
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function doAjaxHeader(_x4, _x5, _x6, _x7) {
        return _doAjaxHeader.apply(this, arguments);
      }
      return doAjaxHeader;
    }()
  }]);
}();
export default AjaxService;